import { featureFlag } from '@atomickit/atomickit-constants';

export const environment = {
	production: true,
  NAME: 'dev',
	API_URL: 'https://dev-server.atomictax.com/api/v1',
	REGION: 'us-east-1',
	USER_POOL_ID: 'us-east-1_4xyqQ0oo8',
	USER_POOL_WEB_CLIENT_ID: '2v244a1t40uccvjuma5u3vic9a',
  ENDPOINT: '',
	AUTHENTICATION_FLOW_TYPE: 'USER_PASSWORD_AUTH',
  /** Same host as merchant SPA; admin static files live under `/admin/` (see CI `s3 sync …/admin/`). */
  adminAppOrigin: 'https://dev.atomictax.com',
  merchantAppOrigin: 'https://dev.atomictax.com',
  adminAppPathPrefix: 'admin',
  autofilerAppOrigin: 'https://dev.atomictax.com',
  autofilerAppPathPrefix: 'autofiler',
  /** Zudoku docs deployed to dev-developers.atomictax.com (`environment.ts` uses http://localhost:9002 for local). */
  developersPortalOrigin: 'https://dev-developers.atomictax.com',
  SENTRY_DSN: 'https://d8ac4d89955f4215be8b7408af90ae1a@o1319042.ingest.sentry.io/6574097',
  UPLOAD_FILES: {
    BUCKET: 'dev-files.atomickit.io',
    REGION: 'us-east-1',
  },
  COGNITO_IDENTITY_POOL_ID: 'us-east-1:e0447cbe-dd13-4fb4-ab80-2dbc25c4b064',
  STRIPE_PUB_KEY: 'pk_test_1ZM0ULAwYmqSeboV5q8ITy6G7a21WEdRq9ky3LdqoaHoZqW0tcAtnliYDRFbAnQecNfSWP2YpRrhbdT7mCZ6KLMdb00pQoScdBW',
  WEBSOCKET_URL: 'wss://dev-server.atomictax.com/ws/v1',
  FEATURE_FLAG: {
    multi_account_switch: featureFlag.FEATURE_FLAG.DEV.multi_account_switch,
    teammates_signup: featureFlag.FEATURE_FLAG.PROD.teammates_signup,
    amazon_linked_account: featureFlag.FEATURE_FLAG.DEV.amazon_linked_account,
    shopify_credit: true,
    suspend_autofiling: featureFlag.FEATURE_FLAG.DEV.suspend_autofiling,
    linked_account_processing: featureFlag.FEATURE_FLAG.DEV.linked_account_processing,
    websocketHistoricFetch: true,
  },
  MIX_PANEL_TOKEN: 'd1fd4001a7c32c53f6ebe870d5f82487',
  GTM_ID: 'GTM-MC85VV6V',
  META_PIXEL_ID: '1334181211024546',
};
